import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyTextArea from '../../../components/forms/textArea'
import MySwitch from '../../../components/forms/switch'

const DisableDeepseek = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({
    fallback_msg: props.data.info.fallback_msg,
    disable_deepseek: props.data.info.disable_deepseek
  })
  const [errorMsg, setErrorMsg] = useState({})

  const handleOk = () => {
    setErrorMsg({})
    if (formValue.disable_deepseek && !formValue.fallback_msg) {
      setErrorMsg({ fallbackMsgEmpty: '兜底话术不能为空' })
      return
    }

    axios.post('/p/chatbot/config/edit', { 
      merchant_oid: merchantOid, 
      fallback_msg: formValue.fallback_msg,
      disable_deepseek: formValue.disable_deepseek
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getChatbotConfig()
          message.success('设置成功！')
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title={'统一欢迎语'}
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存"
    >

      <MySwitch 
        id='disable_deepseek'
        label='是否禁用deepseek回答'
        checked={formValue.disable_deepseek}
        onChange={setFormValue}
      />

      <MyTextArea
        id="fallback_msg"
        minRows={5}
        placeholder='请输入兜底话术'
        value={formValue.fallback_msg}
        onChange={setFormValue}
        errorMsg={errorMsg.fallbackMsgEmpty}
      />
    </Modal>
  )
}

export default DisableDeepseek
